import SuspenseLoader from 'components/SuspenseLoader';
import useRedirectAfterLogin from 'hooks/useRedirectAfterLogin';
import PropTypes from 'prop-types';
import { FC, ReactNode, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'store';
import useBaseLinks from 'store/Auth/Links/useBaseLinks';
import useAuth from 'store/Auth/useAuth';
import customerAllowedRoutes from './customer.routes.json';

interface AuthenticatedProps {
  children: ReactNode;
}

const Authenticated: FC<AuthenticatedProps> = (props) => {
  const { children } = props;
  const navigate = useNavigate();
  const { getLink } = useBaseLinks();
  const { map } = useSelector((state) => state.baseLinks);
  const { getUrl, clearUrl, setUrl } = useRedirectAfterLogin();
  const { isLoggedIn } = useAuth();
  const savedUrl = getUrl();
  const { isCustomer, isLoading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (map) {
      const userLink = getLink('me');
      if (!userLink) {
        localStorage.removeItem('userAuthToken');
        localStorage.removeItem('loggedInUserUUID');
        navigate('login');
      }
    }
  }, [map, getLink, navigate]);

  const isAllowed = customerAllowedRoutes.some((pattern) => {
    if (pattern.includes('${id}')) {
      const regexPattern = pattern.replace('${id}', '[^/]+');
      const regex = new RegExp(`^${regexPattern}$`);
      return regex.test(location.pathname);
    }
    return location.pathname === pattern;
  });

  if (isLoading) {
    return <SuspenseLoader isFullScreen={true} />;
  }

  if (!isLoggedIn) {
    if (location.pathname !== savedUrl) {
      setUrl();
    }
    return <Navigate to={'/login'} />;
  }

  if (savedUrl && location.pathname !== savedUrl) {
    clearUrl();
    return <Navigate to={savedUrl} />;
  }

  if (isCustomer && !isAllowed && location.pathname !== '/access-denied') {
    return <Navigate to="/access-denied" replace />;
  }

  return <>{children}</>;
};

Authenticated.propTypes = {
  children: PropTypes.node,
};

export default Authenticated;
